import React from 'react';
import styles from './EmptyCard.module.scss';
import cn from 'classnames';
import { Empty } from 'antd';

const EmptyCard = ({ description = 'Нет данных', props }) => {
  return (
    <div
      className={cn(styles.root, styles.position)}
      {...props}
    >
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<span className={styles.content}>{description}</span>}
      />
    </div>
  );
};

export default EmptyCard;
